export default __webpack_public_path__ + "static/media/red-map-pin.5cfe432e.png";